import 'css-chunk:src/applications/TermsApp/components/BulkTerms/MessageComposer/MessageComposer.scss';export default {
  "MessageComposer": "_MessageComposer_1kv2h_1",
  "EmailComposer": "_EmailComposer_1kv2h_8",
  "hide": "_hide_1kv2h_11"
};